import { arrayToObject } from "utils/object-util";

export const timeDwellingGroups = {
    LESS_THAN_30_DAYS: 'lessThan30Days',
    MORE_THAN_30_DAYS: 'moreThan30Days',
    MORE_THAN_60_DAYS: 'moreThan60Days'
}

export const timeDwelling = [
    { id: timeDwellingGroups.LESS_THAN_30_DAYS, name: 'Less Than 30 Days', color: 'rgb(155, 220, 138)', listName: 'lessThan30DaysList' },
    { id: timeDwellingGroups.MORE_THAN_30_DAYS, name: 'More Than 30 Days', color: 'rgb(252, 145, 84)', listName: 'moreThan30DaysList' },
    { id: timeDwellingGroups.MORE_THAN_60_DAYS, name: 'More Than 60 Days', color: 'rgb(219, 111, 133)', listName: 'moreThan60DaysList' },
]

export const timeDwellingObj = arrayToObject(timeDwelling)
